import { render, staticRenderFns } from "./dashnav.vue?vue&type=template&id=6dcbf67a&scoped=true&lang=html"
import script from "./dashnav.vue?vue&type=script&lang=js"
export * from "./dashnav.vue?vue&type=script&lang=js"
import style0 from "./dashnav.vue?vue&type=style&index=0&id=6dcbf67a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcbf67a",
  null
  
)

export default component.exports